import React, { useEffect, useState } from "react";
import LogoImg from "../../assets/images/logonew.png";
import TeamImg from "../../assets/images/team.png";
import { ToastContainer, toast, Bounce } from "react-toastify";
import api from "../../setupMiddleware";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import { Link } from "react-router-dom";
import Loader from "../Loader/Loader";
import useApiLoader from "../../Utils/useApiLoader";
import { extractKeys } from "../../Utils/getUserUtitls";

const Login = () => {
  const loading = useApiLoader();

  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setpasswordError] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);

  const handleClickShowPassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const { email, password } = user;

  const signIn = async () => {
    if (!email || !password) {
      if (!email) {
        setUsernameError(true);
      }
      if (!password) {
        setpasswordError(true);
      }
      toast.error("Please enter Username and Password to login!", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      return;
    } else {
      try {
        const res = await api.post("/api/login", { email, password });
        if (res && res.data) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          const userRes = res.data.user;
          const permissionsRes = res.data.permissions;
          const permissions = extractKeys(permissionsRes);
          localStorage.setItem("user", JSON.stringify(userRes));
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("user_role", JSON.stringify(userRes.role));
          localStorage.setItem("permissions", JSON.stringify(permissions));
          window.location = "/";
        }
      } catch (error) {
        if (error) {
          toast.warning(error.response?.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
        }
      }
    }
  };

  const handleEnterKey = (event) => {
    if (event.key === "Enter" || event.keyCode === 13) {
      event.preventDefault(); // prevent form submission or unwanted behavior
      signIn();
    }
  };

  useEffect(() => {});

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="relative rounded-[20px] bg-[#f9f9f9] min-h-screen py-[40px]">
        <div className="max-w-[1340px] min-h-[calc(100vh-80px)] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[30%_60%] items-stretch justify-between px-8 m-auto gap-">
          {/* Left Section (1/3, form centered, footer bottom) */}
          <div className="flex flex-col justify-between items-center md:items-start px-5 py-8">
            {/* Centered Form Content */}
            <div className="flex w-full flex-col justify-center items-center md:items-start flex-grow">
              <div className="block w-full">
                {/* Logo & Title */}
                <div className="flex flex-col items-center md:items-start gap-2.5">
                  <img
                    src={LogoImg}
                    className="w-[200px] object-cover"
                    alt="logo"
                  />
                  <p className="text-xl text-center md:text-left capitalize text-[#142b70]">
                    Sign in your account
                  </p>
                </div>

                {/* Form Fields */}
                <div className="flex flex-col w-full gap-5 mt-12 mb-12">
                  {/* Email */}
                  <div className="flex flex-col gap-2.5">
                    <p className="text-xs text-[#142b70]">Email</p>
                    <input
                      className={`w-full h-[54px] p-2.5 rounded-xl bg-white border-2
                     border-[#ddd] ${
                       usernameError ? "border-[#880000]" : ""
                     } focus:border-[#edc9b7] focus:outline-none shadow-[0px_44px_92px_0_rgba(159,159,159,0.25)]`}
                      type="text"
                      name="email"
                      value={email}
                      onChange={(e) =>
                        setUser({ ...user, email: e.target.value })
                      }
                    />
                  </div>

                  {/* Password */}
                  <div className="flex flex-col gap-2.5 mb-2">
                    <p className="text-xs text-[#142b70]">Password</p>
                    <div className="relative">
                      <input
                        className={`w-full h-[54px] p-2.5 rounded-xl bg-white border-2 border-[#ddd] ${
                          passwordError ? "border-[#880000]" : ""
                        } focus:border-[#edc9b7] focus:outline-none shadow-[0px_44px_92px_0_rgba(159,159,159,0.25)]`}
                        type={passwordShown ? "text" : "password"}
                        name="password"
                        value={password}
                        onChange={(e) =>
                          setUser({ ...user, password: e.target.value })
                        }
                        onKeyDown={(e) => handleEnterKey(e)}
                      />
                      <div
                        className="absolute right-4 top-5 cursor-pointer"
                        onClick={handleClickShowPassword}
                      >
                        {passwordShown ? (
                          <FiEye color="#142b70" />
                        ) : (
                          <FiEyeOff color="#142b70" />
                        )}
                      </div>
                      <Link
                        to={"/forget-password"}
                        className="text-xs text-[#de2b26] float-right font-semibold mt-2 underline hover:text-[#142b70] transition-all"
                      >
                        Forget Password
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Button */}
                <button
                  className="w-full h-[53px] flex justify-center items-center px-[70px] py-3.5 rounded-md bg-[#de2b26] text-base font-medium text-white"
                  onClick={signIn}
                >
                  Login
                </button>
              </div>
            </div>

            {/* Footer at bottom */}
            <p className="mt-8 text-sm text-center md:text-left text-[#142b70]">
              © {new Date().getFullYear()} Money Maestro. All Rights Reserved.
            </p>
          </div>

          {/* Right Section (2/3, full height) */}
          <div className="hidden sm:flex bg-[#142b70] relative rounded-[40px] overflow-hidden justify-center items-center">
            <img
              src={TeamImg}
              alt="Team"
              className="w-full absolute bottom-0"
            />
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default Login;
